import React, { createContext, useContext, useState, useEffect } from 'react';
import transporteurService from '../services/transporteurService';
import { useUser } from './UserContext';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
    const { user } = useUser();
    const [selectedTransporteurId, setSelectedTransporteurId] = useState(null);
    const [subcontractors, setSubcontractors] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSubcontractors = async () => {
            if (user && user.userType === 'responsable_transporteur') {
                setLoading(true);
                try {
                    const data = await transporteurService.getChildTransporteurs();
                    setSubcontractors(data || []);
                } catch (error) {
                    console.error('Error fetching child transporteurs for filter:', error);
                } finally {
                    setLoading(false);
                }
            } else {
                setSubcontractors([]);
                setSelectedTransporteurId(null);
            }
        };

        fetchSubcontractors();
    }, [user]);

    const value = {
        selectedTransporteurId,
        setSelectedTransporteurId,
        subcontractors,
        loading,
        isResponsable: user?.userType === 'responsable_transporteur'
    };

    return (
        <FilterContext.Provider value={value}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error('useFilter must be used within a FilterProvider');
    }
    return context;
};

export default FilterContext;
